
import { defineComponent, ref, PropType } from 'vue'

// Composables
import { UseTrace } from '@/tracing/use-trace'
import { UseDateRange } from '@/use/date-range'
import { Annotation } from '@/org/use-annotations'

// Components
import TraceTimeline from '@/tracing/TraceTimeline.vue'
import EventPanels from '@/tracing/EventPanels.vue'

export default defineComponent({
  name: 'TraceTabs',
  components: {
    TraceTimeline,
    EventPanels,
  },

  props: {
    dateRange: {
      type: Object as PropType<UseDateRange>,
      required: true,
    },
    trace: {
      type: Object as PropType<UseTrace>,
      default: undefined,
    },
    annotations: {
      type: Array as PropType<Annotation[]>,
      default: () => [],
    },
    rootSpanId: {
      type: String,
      default: undefined,
    },
  },

  setup() {
    const activeTab = ref()

    return {
      activeTab,
    }
  },
})
